import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M0.33252 13.0651L5.98779 18.7204L7.39779 17.3004L1.7475 11.6502L0.33252 13.0651ZM22.247 5.28118L11.6478 15.8904L7.41094 11.6436L5.98094 13.0536L11.6478 18.7204L23.667 6.70118L22.247 5.28118ZM18.0086 6.6996L16.5986 5.2796L10.2278 11.6504L11.6478 13.0604L18.0086 6.6996Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CheckAllBig"
);
